/**
 * Decide which status chip a tool card should show. Pure — the component maps
 * the returned variant to colours/tooltip. Agents (category !== 'mcp') are never
 * probed, so they always fall through to their static badge; MCP servers show a
 * live chip once data arrives, "Checking…" while the first probe is in flight,
 * and the static badge if the whole fetch failed.
 * @param {{id:string, category:string, status:string}} tool
 * @param {Record<string,{status:'up'|'down', detail?:string}>} statuses
 * @param {{loading:boolean, error:boolean}} flags
 * @returns {{variant:'up'|'down'|'checking'|'static', label:string, detail?:string}}
 */
export function resolveToolStatus(tool, statuses, flags) {
  const { loading, error } = flags || {};
  const entry = statuses && statuses[tool.id];
  if (entry && entry.status === 'up') return { variant: 'up', label: 'Live' };
  if (entry && entry.status === 'down') {
    return { variant: 'down', label: 'Down', detail: entry.detail };
  }
  const isProbed = tool.category === 'mcp';
  if (isProbed && loading && !error) return { variant: 'checking', label: 'Checking…' };
  return { variant: 'static', label: tool.status };
}
